import { useOnScreenOnce } from '@app/hooks/useOnScreenOnce';
import { useWindowSizing } from '@app/hooks/useSizeWindow';
import { useAppDispatch } from '@app/redux/hooks';
import { ECommerceProduct, ServiceEcommerce2 } from '@app/services/ServiceEcommerce';
import Image from 'next/image';
import { useEffect, useRef } from 'react';
import { AdBanner } from './ads';

interface AdBannerProps {
  banner: AdBanner;
  items?: ECommerceProduct[];
}

export const AdBannerImage = ({ banner, items }: AdBannerProps) => {
  const isMobile = useWindowSizing(990);
  const ref = useRef(null);
  const isVisible = useOnScreenOnce(ref);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isVisible) {
      ServiceEcommerce2.promoView([
        {
          creative_name: banner.name,
          promotion_id: banner.erid,
          promotion_name: banner.name,
          items,
        },
      ]);
    }
  }, [isVisible]);

  const onClick = async () => {
    banner?.handlerAction && dispatch(banner?.handlerAction);
    await ServiceEcommerce2.selectPromotion({
      creative_name: banner.name,
      promotion_id: banner.erid,
      promotion_name: banner.name,
      items,
    });

    await ServiceEcommerce2.promoClick({
      creative_name: banner.name,
      promotion_id: banner.erid,
      promotion_name: banner.name,
      items,
    });

    if (banner.href) {
      setTimeout(() => window.open(banner.href, '_blank'));
    }
  };

  return (
    <div ref={ref}>
      <Image
        src={isMobile ? banner?.imageMobile : banner?.imageDesktop}
        width={isMobile ? banner.options?.widthMobile || 1152 : banner.options?.widthDesktop || 2280}
        height={isMobile ? banner.options?.heightMobile || 460 : banner.options?.heightDesktop || 300}
        layout="responsive"
        priority
        alt={banner.name}
        onClick={onClick}
      />
    </div>
  );
};
